import React from 'react';
import PropTypes from 'prop-types';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { GlobalNavigationSearch } from 'site-modules/shared/components/inventory/global-search/global-navigation-search/global-navigation-search';

import './search-box.scss';

export function SearchBox({ isMobile }) {
  return (
    <FeatureFlag name="disable-global-nav-llm">
      {disableLlm => <GlobalNavigationSearch isMobile={isMobile} withLlmSearchDisabled={disableLlm} />}
    </FeatureFlag>
  );
}

SearchBox.propTypes = {
  isMobile: PropTypes.bool,
};

SearchBox.defaultProps = {
  isMobile: false,
};
